export default __webpack_public_path__ + "static/media/programList.7e2c4aa5.png";